import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/api/client";
import { useAuth } from "@/context/AuthContext";

const TrackerAccessContext = createContext(null);

export function TrackerAccessProvider({ children }) {
  const { user } = useAuth();
  const [access, setAccess] = useState({ hasAccess: false, isAdmin: false, projects: [], loading: true });

  const refresh = useCallback(async () => {
    if (!user) { setAccess({ hasAccess: false, isAdmin: false, projects: [], loading: false }); return; }
    try {
      const { data } = await api.get("/tracker/access");
      setAccess({ hasAccess: data.has_access, isAdmin: data.is_admin, projects: data.projects || [], loading: false });
    } catch {
      setAccess({ hasAccess: false, isAdmin: false, projects: [], loading: false });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return <TrackerAccessContext.Provider value={{ ...access, refresh }}>{children}</TrackerAccessContext.Provider>;
}

export const useTrackerAccess = () => useContext(TrackerAccessContext);
